
import React, { useEffect, useState } from 'react'

import bgImg from '../assets/AccountGradientBG.png'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getAuth } from "firebase/auth"
import { UserAuth } from '../context/AuthContext'

import { db } from "../firebase"
import {
    collection,
    onSnapshot,
    query,
    where
} from "firebase/firestore"

import './licenses.css'

const Licenses = () => {

    const [userLicenses, setUserLicenses] = useState([]);
    const [allOwnedProducts, setAllOwnedProducts] = useState([]);
    const { user, logOut } = UserAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // Prioritize URL parameters before falling back to localStorage
    const searchParams = new URLSearchParams(location.search || window.location.search);
    const urlMachineId = searchParams.get('machine_id');
    const urlProduct = searchParams.get('product');
    const pluginProduct = urlProduct || localStorage.getItem('plugin_product');
    const isRefract = pluginProduct?.toLowerCase() === 'refract';

    //fetch purchased products
    useEffect(() => {
        if (user.uid) {
            const q = query(collection(db, "purchasedProducts"), where("user", "==", user.uid));

            onSnapshot(q, (snapshot) => {
                setAllOwnedProducts(snapshot.docs.map(doc => {
                    const productData = doc.data();
                    const availableLicenses = [productData.license1, productData.license2].filter(
                        (license) => license !== ""
                    ).length;

                    return {
                        id: doc.id,
                        viewing: false,
                        availableLicenses,
                        ...productData
                    }
                }))
            })
        }
    }, [user.uid])

    const newLicense = (_id) => {
        const product = allOwnedProducts?.find(p => p.id === _id);
        console.log("Licenses.jsx: Clicked license:", _id, product);
        if (product && product.availableLicenses < 2) {
            const machineId = urlMachineId || localStorage.getItem('plugin_machine_id');
            console.log("Licenses.jsx: Primary variables - pluginProduct:", pluginProduct, "machineId:", machineId);

            if (pluginProduct && machineId) {
                // Bypass the legacy C++ ping-pong polling if we already have the machine_id!
                const navUrl = `/${pluginProduct.toLowerCase()}/create/fb/${_id}/${machineId}/${product.availableLicenses + 1}`;
                console.log("Licenses.jsx: Navigating to direct FB creation:", navUrl);
                navigate(navUrl);
            } else {
                // Fallback for older Aurora plugin which relies on C++ URL interception
                const navUrl = `/aurora/create/1/${_id}/${product.availableLicenses + 1}`;
                console.log("Licenses.jsx: Fallback navigating to Aurora legacy poll:", navUrl);
                navigate(navUrl);
            }
        }
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    let renderPurchasedProducts = null;
    if (allOwnedProducts && allOwnedProducts.length > 0) {
        renderPurchasedProducts = allOwnedProducts.map((product) => {
            const isProductRefract = product.name?.toLowerCase() === 'refract';
            return (
                <div key={product.id} className="lic__prod" onClick={() => { newLicense(product.id) }}>
                    <div className={`lic__prodinfo ${isProductRefract ? 'refract-prodinfo' : ''}`}>
                        <div className="lic__prodtext">
                            <h3>{capitalizeFirstLetter(product.name)}</h3>
                            <div className="lic__prodavailable">
                                <p>{product.availableLicenses}/2</p>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <div className={`lic__container ${isRefract ? 'refract-bg' : ''}`}>
            {!isRefract && (
                <div className="lic__bg">
                    <img src={bgImg} alt="img" className='lic__imgsize' />
                </div>
            )}

            <div className="lic__content">

                <div className="lic__title">
                    Available licenses
                </div>

                <div className="lic__ontop">
                    {renderPurchasedProducts}
                </div>
            </div>

            <div className="lic__support">
                Sometimes licenses can take some time to appear because of transaction validation. If you have been experiencing that
                for some time you can contact customer support support@tapesignal.com and we'll get you sorted.
            </div>
        </div>
    )
}

export default Licenses
